import { render, staticRenderFns } from "./OrgEffortChart.vue?vue&type=template&id=1664aaa1&scoped=true&"
import script from "./OrgEffortChart.vue?vue&type=script&lang=js&"
export * from "./OrgEffortChart.vue?vue&type=script&lang=js&"
import style0 from "./OrgEffortChart.vue?vue&type=style&index=0&id=1664aaa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1664aaa1",
  null
  
)

export default component.exports